// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 65 ? "initial" : chunkId) + "." + {"65":"0917eb7c","116":"366dedaf","209":"2ba954dd","268":"c591547e","404":"1d62614b","467":"80f235fd","699":"c34eabad","727":"992a4cd7","807":"92c35502"}[chunkId] + ".chunk.js";
};